<p-dialog
  modal="true"
  styleClass="atlas-dialog-s"
  position="top"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h4 *ngIf="pledgeCampaign">{{ 'revenue.pledge.add.header' | translate | titlecase }} for {{ pledgeCampaign.CampaignName }}</h4>
  </ng-template>
  <form #crudForm="ngForm" class="atlas-form">
    <div *ngIf="profile" class="mb-20">
      <wl-profile-type-icon
        [isMember]="profile.Member"
        [isOrg]="profile.OrgInd"
        [profileId]="profile.ProfileId"
        [styleOverrides]="{ 'max-width': '34px', 'max-height': '34px' }"
        class="mr-11"
      ></wl-profile-type-icon>
      <strong>{{ profile.ReportName }}</strong
      >&nbsp; <span style="color: #999">({{ profile.ProfileId }})</span>&nbsp;
    </div>
    <div  class="mb-20 w-100 mct-flex mct-col">
      <label class="light-text">{{ 'revenue.pledge.add.start-date' | translate | titlecase }}</label>
      <wl-date-selector ngDefaultControl [required]="true" name="startDate" [(ngModel)]="pledge.StartDate"></wl-date-selector>
    </div>
    <div class="mb-20">
      <label class="light-text">{{ 'revenue.pledge.add.end-date' | translate | titlecase }}</label>
      <wl-date-selector ngDefaultControl [required]="true" name="endDate" [(ngModel)]="pledge.EndDate"></wl-date-selector>
    </div>
    <div  class="w-100 mb-20 mct-flex mct-col">
      <label class="light-text">{{ 'revenue.pledge.add.pledge-amount-total' | translate | titlecase }}</label>
      <div class="p-inputgroup">
        <span class="atlas-input-addon">$</span>
        <p-inputNumber
          required
          name="pledgeAmountTotal"
          [(ngModel)]="pledge.PledgeTotal"
          showClear="true"
          mode="decimal"
          [style]="{ width: '100%' }"
          [min]="0"
        ></p-inputNumber>
      </div>
    </div>
    <div  class="w-100 mb-20 mct-flex mct-col">
      <label class="light-text">{{ 'revenue.pledge.add.pledge-years' | translate | titlecase }}</label>
      <p-inputNumber
        [required]="this.autoCreateBill"
        name="pledgeYears"
        [(ngModel)]="pledge.PledgeYears"
        showClear="true"
        [style]="{ width: '100%' }"
        [min]="0"
      ></p-inputNumber>
    </div>
    <div class="mb-20">
      <label class="light-text">{{ 'revenue.pledge.add.pledge-level' | translate | titlecase }}</label>
      <p-select
        appendTo="body"
        name="pledgeLevel"
        [(ngModel)]="pledge.PledgeLevel"
        [options]="pledgeLevels"
        showClear
        [placeholder]="'revenue.pledge.add.pledge-level-placeholder' | translate | titlecase"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
    <div class="mb-20">
      <label class="light-text">{{ 'revenue.pledge.add.revenue-item' | translate | titlecase }}</label>
      <p-select
        appendTo="body"
        name="revenueItem"
        [(ngModel)]="pledge.ItemNum"
        [options]="revItems"
        showClear
        [placeholder]="'revenue.pledge.add.revenue-item-placeholder' | translate | titlecase"
        [style]="{ width: '100%' }"
        [required]="this.autoCreateBill"
      ></p-select>
    </div>
    <div class="mb-20">
      <label class="light-text">{{ 'revenue.pledge.add.billing-cycle' | translate | titlecase }}</label>
      <p-select
        appendTo="body"
        name="billingCycle"
        [(ngModel)]="pledge.BillingCycle"
        [options]="billCycles"
        showClear
        [placeholder]="'revenue.pledge.add.billing-cycle-placeholder' | translate | titlecase"
        [style]="{ width: '100%' }"
        [required]="this.autoCreateBill"
      ></p-select>
    </div>
    <div class="mb-20">
      <label class="light-text">{{ 'revenue.pledge.add.assigned-to' | translate | titlecase }}</label>
      <p-select
        appendTo="body"
        name="assignedTo"
        [(ngModel)]="pledge.AssignedTo"
        [options]="activeUsers"
        showClear
        [placeholder]="'revenue.pledge.add.assigned-to-placeholder' | translate | titlecase"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
    <div class="mb-20">
      <label class="light-text">{{ 'revenue.pledge.add.notes' | translate | titlecase }}</label>
      <textarea pInputTextarea [(ngModel)]="pledge.Notes" name="notes"></textarea>
    </div>
    <div class="mb-20">
      <p-checkbox name="autoCreateBill" [(ngModel)]="autoCreateBill" [binary]="true" inputId="autoCreateBill"> </p-checkbox>
      <label for="autoCreateBill">
        {{ 'revenue.pledge.add.auto-create-bill' | translate | titlecase }}
      </label>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!crudForm.valid" (click)="save()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
